import { CalendarDate, CalendarDateTime } from '@internationalized/date';
import { DateField, type DateFieldProps } from './DateField';
import { convertFromDateFieldValue, convertToDateFieldValue } from '~/util/date';

export interface DateTimeFieldProps extends Omit<DateFieldProps<CalendarDate | CalendarDateTime>, 'value' | 'onChange'> {
	value: Date | null;
	onChange: (value: Date | null) => void;
}

export function DateTimeField(
	props: Omit<DateFieldProps<CalendarDate | CalendarDateTime>, 'value' | 'onChange'> & {
		value: Date | null;
		onChange: (value: Date | null) => void;
	}
) {
	const calendarDateValue = props.value ? convertToDateFieldValue(props.value, props.granularity) : null;

	const onChange = (newValue: CalendarDate | CalendarDateTime | null) => {
		props.onChange(newValue ? convertFromDateFieldValue(newValue) : null);
	};

	return <DateField {...props} value={calendarDateValue} onChange={onChange} />;
}
